import Image from 'app/Components/Shared/Image/image';
import React, {useEffect} from 'react';
import './Toast.scss';
import check from './images/check.svg';
const Toast = ({message, isVisible, onClose, duration = 1500}) => {
  useEffect(() => {
    if (isVisible) {
      const timer = setTimeout(() => {
        onClose();
      }, duration);

      return () => clearTimeout(timer);
    }
  }, [isVisible, onClose, duration]);

  if (!isVisible) return null;

  return (
    <div className='funtone-toast'>
      <div className='funtone-toast-content'>
        <span className='funtone-toast-message'>{message} <Image src={check} alt="icon" /></span>
      </div>
    </div>
  );
};

export default Toast;
